import React from "react";
import useApiEp from "../hooks/useApiEp";

const ProfileViewer = ({ id }) => {
  const { isLoading, isError, error, data } = useApiEp(
    `/user/profile-view?id=${encodeURIComponent(id)}`
  );
  return <></>;
};

export default ProfileViewer;
